module.exports = __webpack_public_path__ + "static/img/meeting-agenda.ec01210f.jpg";